import "./index.scss";

function Spinner() {
  return (
    <div className="three-body">
      <div class="three-body__dot"></div>
      <div class="three-body__dot"></div>
      <div class="three-body__dot"></div>
    </div>
  );
}

export default Spinner;
